<script>
import provider from "../../libs/provider";

export default {
	mounted() {
		switch (provider.get().providerCode) {
			case "apl":
				window.location.replace(process.env.VUE_APP_EDU_APL_AUTH_URL);
				break;
			case "gapps":
				window.location.replace(process.env.VUE_APP_EDU_GAPPS_AUTH_URL);
				break;
			case "gappsm":
				window.location.replace(process.env.VUE_APP_EDU_GAPPSM_AUTH_URL);
				break;
			case "msft":
				window.location.replace(process.env.VUE_APP_EDU_MSFT_AUTH_URL);
				break;
			case "msad":
				window.location.replace(process.env.VUE_APP_EDU_MSAD_AUTH_URL);
				break;
		}
	}
};
</script>
